var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"product-text"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('product-image-container',{attrs:{"tarjetas":_vm.tarjetas,"listadoTarjetas":_vm.listadoTarjetas,"quantumObfuscate":_vm.quantumObfuscate}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }